import React from 'react';
import { Trans } from '@lingui/macro';
import { PriceType, PricesStateType } from '@/types';

interface PriceCellProps {
    hasGroupBooking: boolean;
    hasMultipleResource: boolean;
    hasMultiplePrices: boolean;
    pricesState: PricesStateType;
    price: PriceType;
}

const Price: React.FC<PriceCellProps> = ({
    hasGroupBooking,
    hasMultipleResource,
    hasMultiplePrices,
    pricesState,
    price,
}) => {
    const priceText = price.PriceText || `${price.Price}${price.PriceSign || ''}`;
    const displayPriceText = price.Category && priceText.includes(price.Category)
        ? priceText.split('-').slice(1).join('-').trim() || priceText
        : priceText;
    return (
        <>
            {!(hasGroupBooking || hasMultipleResource) &&
                hasMultiplePrices ? (
                <>
                    {pricesState.data?.PriceDetails.reduce((acc, curr) => {
                        acc = acc + curr.Price;
                        return acc;
                    }, 0)}{pricesState.data?.PriceSign}
                </>
            ) : (
                <>
                    {displayPriceText}
                </>
            )}
        </>
    );
};

export default Price;
